












































import { Component, Mixins } from "vue-property-decorator";
import { DocumentKind } from "../../../domain/document";
import { IMultiSelectableAsynchronously, IMultiSelectableConditionallyAsynchronously, SelectorDialogMixin } from "../../system";
import MultiDocumentKindListSelector from "../selectors/MultiDocumentKindListSelector.vue";
import { IDocumentKindListSelectorDialogCondition } from "./IDocumentKindListSelectorDialogCondition";
import { IMultiDocumentKindListSelectorDialogCondition } from "./IMultiDocumentKindListSelectorDialogCondition";

@Component({
  components: {
    MultiDocumentKindListSelector,
  }
})
export default class MultiDocumentKindListSelectorDialog extends Mixins(SelectorDialogMixin) implements IMultiSelectableAsynchronously<DocumentKind>, IMultiSelectableConditionallyAsynchronously<DocumentKind, IDocumentKindListSelectorDialogCondition> {
  data(): any {
    return {
      title: this.$wording.format.attributes.name + "種別",
    };
  }
  title: string;

  async selectOptions(defaultOptions?: DocumentKind[]): Promise<DocumentKind[]> {
    return this.show<DocumentKind[]>(defaultOptions);
  }

  async selectOptionsConditionally(condition: IMultiDocumentKindListSelectorDialogCondition, defaultOption?: DocumentKind[]): Promise<DocumentKind[]> {
    return this.show<DocumentKind[]>(defaultOption);
  }
}
